// extracted by mini-css-extract-plugin
export default {"body":"detailsbox_body__E2nxj","imgdiv":"detailsbox_imgdiv__4dLbM","stats":"detailsbox_stats__Ugd85"};